var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C24 31.1046 23.1046 32 22 32C20.8955 32 20 31.1046 20 30C20 28.8954 20.8955 28 22 28C23.1046 28 24 28.8954 24 30Z",
    fill: "#05205F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H20L20.8 26H23.2L24 14Z",
    fill: "#05205F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4517 2.89433C23.9067 0.256088 20.0933 0.256088 18.5483 2.89433L1.27735 32.3872C-0.284176 35.0538 1.63889 38.4085 4.72907 38.4085H39.2709C42.3611 38.4085 44.2842 35.0538 42.7227 32.3872L25.4517 2.89433ZM41.4282 33.1452L24.1574 3.65233C23.1917 2.00343 20.8083 2.00343 19.8427 3.65233L2.57175 33.1452C1.5958 34.8118 2.7977 36.9085 4.72907 36.9085H39.2709C41.2023 36.9085 42.4042 34.8118 41.4282 33.1452Z",
    fill: "#05205F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.f728a9513507613ed5dc563946772c64.svg";
export { ForwardRef as ReactComponent };